import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect, Provider, ReactReduxContext } from 'react-redux';
import { browserHistory, Link } from 'react-router';
import * as _ from 'lodash';
import moment from 'moment';
import 'react-date-range/dist/styles.css'; // main style file

import 'react-date-range/dist/theme/default.css'; // theme css file

import { DateRangePicker } from 'react-date-range';
import { loadAllAds } from 'redux/modules/ads';
import Popover from 'material-ui/Popover';
import Dialog from 'material-ui/Dialog';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import Helmet from 'react-helmet';
import RaisedButton from 'material-ui/RaisedButton';
import { AppLayout } from 'containers';
import { AdDashboardCard, AdDetails, AdTypeIcon, CardRow, DataTable, EmptyState, PageHeader, Spinner } from 'components';
var AdsList = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    allAds: state.ads.allAds,
    organization: state.organization.current,
    theme: state.theme,
    loadingAllAds: state.ads.loadingAllAds,
    adAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null
  };
}, {
  loadAllAds: loadAllAds
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AdsList, _Component);

  var _super = _createSuper(AdsList);

  function AdsList(props) {
    var _this;

    _classCallCheck(this, AdsList);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "fetchFacebookAdsInAccount", function () {
      var sa = _this.props.organization.SocialAccounts.find(function (sa) {
        return _this.props.adAccount && "".concat(sa.id) === "".concat(_this.props.adAccount.socialAccountId);
      });

      if (sa) {
        return _this.props.loadAllAds(_this.props.organization.id, sa.id);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "formatData", function (ads, nowMoment) {
      // only going to hand back ads in selected date range
      var start = moment(_this.state.ranges[0].startDate);
      var end = moment(_this.state.ranges[0].endDate);
      return ads.filter(function (ad) {
        return moment(ad.campaign.start_time).isBetween(start, end) || moment(ad.campaign.stop_time).isBetween(start, end);
      }).sort(function (a, b) {
        return moment(b.campaign.stop_time).format('YYYYMMDD') - moment(a.campaign.stop_time).format('YYYYMMDD');
      }).map(function (a) {
        if (a) {
          var hasInsights = a.insights && a.insights.summary;
          var imgUrl = a.creative && a.creative.thumbnail_url ? a.creative.thumbnail_url : 'https://s3.amazonaws.com/likeabucket/user_upload/22/YAeZfa747.png';
          var status = moment(a.campaign.start_time).startOf('day').isAfter(nowMoment) ? 'Upcoming' : moment(a.campaign.start_time).startOf('day').isBefore(nowMoment) && moment(a.campaign.stop_time).endOf('day').isAfter(nowMoment) ? 'In Progress' : 'Completed';
          var dates = /*#__PURE__*/React.createElement("div", {
            style: {
              fontSize: 14,
              width: 200
            }
          }, moment(a.campaign.start_time).format('MM/DD/YYYY'), " -", ' ', moment(a.campaign.stop_time).format('MM/DD/YYYY'));
          return {
            id: a.id,
            status: _this.formatTableText(status),
            name: a.name ? /*#__PURE__*/React.createElement("div", {
              style: {
                display: 'flex',
                alignItems: 'flex-start',
                maxWidth: 275,
                minWidth: 225
              }
            }, /*#__PURE__*/React.createElement("img", {
              src: imgUrl,
              style: {
                height: 50,
                marginRight: 8
              }
            }), /*#__PURE__*/React.createElement("div", null, _.startsWith(a.name, 'act_') ? _this.formatTableText('Promoted Post') : _this.formatTableText(a.name))) : '',
            objective: /*#__PURE__*/React.createElement("div", {
              style: {
                minWidth: 150,
                fontSize: 14
              }
            }, _.startCase(a.campaign.objective.toLowerCase())),
            dates: dates,
            cpc: hasInsights && a.insights.summary.cpc ? _this.formatTableText("$".concat(a.insights.summary.cpc.toFixed(2))) : _this.formatTableText('-'),
            spend: hasInsights && a.insights.summary.spend ? _this.formatTableText("$".concat(a.insights.summary.spend.toFixed(2))) : _this.formatTableText('-'),
            impressions: hasInsights && a.insights.summary.impressions ? _this.formatTableText(a.insights.summary.impressions) : _this.formatTableText('-'),
            reach: hasInsights && a.insights.summary.reach ? _this.formatTableText(a.insights.summary.reach) : _this.formatTableText('-')
          };
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "formatTableText", function (text) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 14
        }
      }, text);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelect", function (ranges) {
      _this.setState({
        ranges: [{
          key: 'range1',
          startDate: ranges.range1.startDate,
          endDate: ranges.range1.endDate
        }]
      });
    });

    var startDate = moment().subtract(1, 'month');
    var endDate = moment().format();
    _this.state = {
      clickedAdId: null,
      dateRangePickerOpen: false,
      ranges: [{
        startDate: moment(startDate).toDate(),
        endDate: moment(endDate).toDate(),
        key: 'range1'
      }]
    };
    return _this;
  }

  _createClass(AdsList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.adAccount) {
        this.fetchFacebookAdsInAccount();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevProps.adAccount && this.props.adAccount) {
        this.fetchFacebookAdsInAccount();
      }
    }
  }, {
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var _this2 = this;

      var dateRangeStartText = moment(this.state.ranges[0].startDate).format('MMM D, YYYY');
      var dateRangeEndText = moment(this.state.ranges[0].endDate).format('MMM D, YYYY');
      var dateRangeText = "".concat(dateRangeStartText, " - ").concat(dateRangeEndText);
      var nowMoment = moment();
      var adsData = this.props.allAds ? this.formatData(this.props.allAds.ads, nowMoment) : [];
      var headerFields = [{
        name: 'Status',
        key: 'status'
      }, {
        name: 'Name',
        key: 'name'
      }, {
        name: 'Objective',
        key: 'objective'
      }, {
        name: 'Dates',
        key: 'dates'
      }, {
        name: 'Impressions',
        key: 'impressions'
      }, {
        name: 'Reach',
        key: 'reach'
      }, {
        name: 'Spend',
        key: 'spend'
      }, {
        name: 'CPC',
        key: 'cpc'
      }];

      if (this.props.loadingAdAccount || this.props.loadingAllAds) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            position: 'relative'
          }
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      var adDetails = null;

      if (this.state.clickedAdId) {
        adDetails = this.props.allAds.ads.find(function (a) {
          return parseInt(a.id) === parseInt(_this2.state.clickedAdId);
        });
      }

      var modalActions = adDetails && adDetails.campaign.objective === 'LEAD_GENERATION' ? [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Export Results",
        onClick: function onClick() {
          return _this2.fetchResults(adDetails.id);
        }
      })] : [];
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Helmet, {
        title: "Advertising - All Ads"
      }), /*#__PURE__*/React.createElement("div", {
        className: "container-fluid"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          padding: '0 36px'
        }
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Advertising",
        secondary: "All Ads",
        style: {
          marginBottom: 8
        },
        pageTitleStyle: {
          marginTop: 0
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: 32,
          maxWidth: 320
        }
      }, /*#__PURE__*/React.createElement(Menu, null, /*#__PURE__*/React.createElement(MenuItem, {
        primaryText: dateRangeText,
        onClick: function onClick(event) {
          _this2.setState({
            dateRangePickerOpen: true,
            anchorEl: event.currentTarget
          });
        },
        style: {
          borderBottom: '1px solid #dfdfdf'
        }
      })), /*#__PURE__*/React.createElement(Popover, {
        open: this.state.dateRangePickerOpen,
        anchorEl: this.state.anchorEl,
        anchorOrigin: {
          horizontal: 'left',
          vertical: 'bottom'
        },
        targetOrigin: {
          horizontal: 'left',
          vertical: 'top'
        },
        onRequestClose: function onRequestClose() {
          _this2.setState({
            dateRangePickerOpen: false
          });
        }
      }, /*#__PURE__*/React.createElement(DateRangePicker, {
        ranges: this.state.ranges,
        onChange: this.handleSelect
      }))), /*#__PURE__*/React.createElement("div", {
        style: {
          margin: '0 36px'
        }
      }, adsData.length ? /*#__PURE__*/React.createElement(DataTable, {
        noRowClasses: true,
        headerFields: headerFields,
        displaySearch: false,
        onRowSelection: function onRowSelection(data) {
          _this2.setState({
            clickedAdId: data.id
          }, function () {});
        },
        data: adsData,
        loading: this.props.loadingAllAds,
        style: {
          width: '100%'
        },
        hideSort: true
      }) : /*#__PURE__*/React.createElement(EmptyState, {
        text: "No ads for this date range.",
        iconName: "ion-map",
        iconSize: "95px"
      }))), adDetails && /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (ctx) {
        return /*#__PURE__*/React.createElement(Dialog, {
          title: /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement("div", {
            className: "row"
          }, /*#__PURE__*/React.createElement("div", {
            className: "col-xs-9"
          }, /*#__PURE__*/React.createElement(AdTypeIcon, {
            style: {
              "float": 'left',
              marginRight: 8
            },
            adType: adDetails.campaign.objective,
            size: "large"
          }), /*#__PURE__*/React.createElement("span", {
            style: {
              fontSize: 22,
              color: 'rgb(97, 97, 97)',
              fontWeight: 400
            }
          }, "".concat(_.startCase(adDetails.campaign.objective.toLowerCase()), " - ").concat(adDetails.name))))),
          autoScrollBodyContent: true,
          open: _this2.state.clickedAdId,
          onRequestClose: function onRequestClose() {
            _this2.setState({
              clickedAdId: null
            });
          },
          actions: modalActions,
          actionsContainerStyle: {
            padding: 12
          },
          bodyStyle: {
            padding: 0
          },
          contentStyle: {
            maxWidth: 1200,
            width: '97%'
          }
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement(AdDetails, {
          adDetails: adDetails,
          upcoming: _this2.props.type === 'upcoming'
        })));
      }));
    }
  }]);

  return AdsList;
}(Component)) || _class);
export { AdsList as default };